// extracted by mini-css-extract-plugin
export default {"Heading":"fH7tmDUB"};